import { render } from "./breathing-circle.vue?vue&type=template&id=c32ef9ae&scoped=true"
import script from "./breathing-circle.vue?vue&type=script&lang=js"
export * from "./breathing-circle.vue?vue&type=script&lang=js"

import "./breathing-circle.vue?vue&type=style&index=0&id=c32ef9ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c32ef9ae"]])

export default __exports__